import {
    OperatingHours,
    WeeklySchedule,
} from "../../../../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"

const daysOfWeek: { [key: number]: string } = {
    1: "monday",
    2: "tuesday",
    3: "wednesday",
    4: "thursday",
    5: "friday",
    6: "saturday",
    7: "sunday",
}

export const getScheduleWithDefaults = (data: WeeklySchedule[]): { [key: string]: OperatingHours } => {
    const schedule: { [key: string]: OperatingHours } = {}

    Object.keys(daysOfWeek).forEach((dayNumber) => {
        const day = daysOfWeek[Number(dayNumber)]
        const dayData = data.find((d) => d.weekDayNumber === Number(dayNumber))

        if (dayData) {
            schedule[day] = dayData.hours
        } else {
            schedule[day] = { open: "closed", close: "" }
        }
    })

    return schedule
}
